<template>
    <v-container :class="$style.postActionFeedWrapper">
        <AccountValidateFeed v-if="responseCategory=='success'" :details="details" :subActionTyp="subActionTyp" @close="$emit('close')"/>
        <SystemFailureFeed v-if="responseCategory=='error'" :actionButtonState="failureActionButtonState" :targetAction="'close'" @doTargetAction="doTargetAction" :feedDetails="responseAddInfo"/>
    </v-container>
</template>

<script>
import AccountValidateFeed from '@/components/Login_Register/AccountValidateFeed.vue';
import SystemFailureFeed from '@/components/UI/SystemFailureFeed.vue';

export default {
    name: "PostActionFeed",
    components: {
        AccountValidateFeed,
        SystemFailureFeed
    },            
    props: {
        response: {
            required: true
        },
        failureActionButtonState: {
            type: String
        },
        subActionTyp: {
            type: String,
            default: null
        }
    },
    data: function(){
        return {
            responseAddInfo: null
        }
    },
            
    methods: {
        doTargetAction: function(targetAction){
            this.$emit(targetAction,'register');
        },
        obtainResponseCategory: function(){
            this.responseAddInfo = null;
            if (this.response.status==200) {
                if (this.response.data.security !== undefined && this.response.data.security.register !== undefined){
                    this.responseAddInfo = this.response.data.security.register.result===true ? this.responseAddInfo : this.response.data.security.register.error;
                    return this.response.data.security.register.result===true ? 'success' : 'error'; 
                }
                if (this.response.data.security !== undefined && this.response.data.security.sendAccountValidationLink !== undefined){
                    this.responseAddInfo = this.response.data.security.sendAccountValidationLink.result===true ? this.responseAddInfo : this.response.data.security.sendAccountValidationLink.error;                    
                    return this.response.data.security.sendAccountValidationLink.result===true ? 'success' : 'error'; 
                }
                if (this.response.data.program !== undefined && this.response.data.program.addToUser !== undefined){
                    if (this.response.data.program.addToUser.existing!==undefined){
                        return 'success';
                    }                

                    return this.response.data.program.addToUser.result===true ? 'success' : 'error';
                }
            }
            
            return 'error';
        },        
    },
    computed: {
        details: function(){
            let details = JSON.parse(this.response.config.data);
            if (details.user === undefined){
                details.user = details;
            }
            
            return details;
        },
        responseCategory(){
            return this.obtainResponseCategory(); //function access value in observer thus have take it out from Computed. Observer in Computed is instantly Null
        },
    },
    watch: {

    }
}
</script>

<style module>

.postActionFeedWrapper {
    margin: 0 auto !important;
    background-image: url("../../assets/images/validate_feed_bkg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center bottom;
}

</style>